import { upperFirst, toLower } from 'lodash'

export const capitalize = text => {
  return upperFirst(toLower(text))
}

/**
 * Extract the root domain from a subdomain
 * Examples:
 * - mails.microsoft.com -> microsoft.com
 * - example.co.uk -> example.co.uk
 * - subdomain.example.com -> example.com
 * - example.com -> example.com
 *
 * @param {string} domain - The domain to extract from
 * @returns {string} The root domain
 */
export const getRootDomain = domain => {
  if (!domain || typeof domain !== 'string') {
    return domain
  }

  // Remove protocol if present
  let cleanDomain = domain.replace(/^https?:\/\//, '')

  // Remove path if present
  cleanDomain = cleanDomain.split('/')[0]

  // Remove port if present
  cleanDomain = cleanDomain.split(':')[0]

  // Split by dots
  const parts = cleanDomain.split('.')

  // If less than 2 parts, return as is
  if (parts.length < 2) {
    return cleanDomain
  }

  // List of known multi-level TLDs
  const multiLevelTlds = [
    'co.uk',
    'co.jp',
    'co.in',
    'co.za',
    'co.nz',
    'co.kr',
    'com.au',
    'com.br',
    'com.cn',
    'com.mx',
    'com.ar',
    'ac.uk',
    'gov.uk',
    'org.uk',
    'net.uk',
    'ne.jp',
    'or.jp',
    'go.jp',
    'net.au',
    'org.au',
    'gov.au',
    'co.id',
    'ac.id',
    'or.id'
  ]

  // Check if domain ends with a multi-level TLD
  for (const tld of multiLevelTlds) {
    if (cleanDomain.endsWith(`.${tld}`)) {
      // Return domain.tld (e.g., example.co.uk)
      const tldParts = tld.split('.')
      const domainParts = parts.slice(-(tldParts.length + 1))
      return domainParts.join('.')
    }
  }

  // Standard case: return last two parts (domain.tld)
  return parts.slice(-2).join('.')
}
